/**
 * Sunucudan dönen hatanın taşıyıcısı.
 *
 * `api.ts` yerine ayrı bir modülde durur: mock API bu sınıfı üretebilmek için ihtiyaç
 * duyuyor, `api.ts` ise mock API'yi kuruyor — ikisi birbirini doğrudan içe aktarsaydı
 * modüller arasında döngü oluşurdu.
 */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly correlationId?: string;

  constructor(message: string, status: number, code: string, correlationId?: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    if (correlationId) this.correlationId = correlationId;
  }
}
